// localStorage keys shared across features. Add new app-wide keys here instead
// of repeating the raw string; feature-only keys belong in that feature's
// own constants file.
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  USER_PROFILE_DATA: 'userProfileData',
  DOCTOR_PROFILE: 'doctorProfile',
  DOCTOR_SETTINGS: 'doctorSettings',
  DOCTOR_BALANCE: 'doctor_balance',
  LOCATIONS: 'locations',
  ROLE_ID: 'roleId',
  VIEW_MODE: 'viewMode',
  PP_VIEW_MODE: 'ppViewMode',
  AR_VIEW_MODE: 'arViewMode',
  LANGUAGES: 'languages',
  ENVIRONMENT: 'environment',
  FREEZE_URL: 'freeze_url',
  SUBSCRIPTION_DATA: 'subscription_data',
  CURRENT_LOC: 'currentLoc',
  /** Social platform master list (platform_id, platform_name, platform_type) returned at login. */
  SOCIAL_PLATFORMS_DATA: 'social_platforms_data',
  /** Delivered-terminal count returned at login as `terminalsql`; gates the terminal-only cards. */
  TOTAL_TERMINALS: 'total_terminals',
  /** doctor_settings_extended.review_flow at login: 1 once a terminal is marked delivered. With
   *  terminal_flow_enabled it gates the post-payment review prompt, mirroring the backend. */
  REVIEW_FLOW: 'review_flow',
  /** skip_customer_info at login: 1 lets the merchant skip the Customer Information step in process payment. */
  SKIP_CUSTOMER_INFO: 'skip_customer_info',
  /** pp_skip_max_amount at login: above this service amount the skip isn't offered (normal flow); 0 = no limit. */
  PP_SKIP_MAX_AMOUNT: 'pp_skip_max_amount'
};
